import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { BillingInterceptor } from './core/interceptors/billing.interceptor';
import { ApiLogInterceptor } from './core/interceptors/api-log.interceptor';
import { PermissionInterceptor } from './core/interceptors/permission.interceptor';
import { NoAutofillService } from './core/services/no-autofill.service';
import { ChunkErrorHandler } from './core/services/chunk-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ApiLogInterceptor, multi: true },
    // v1.6.1538 — billing 403 from any staff route (Asana 1218431462710845).
    { provide: HTTP_INTERCEPTORS, useClass: BillingInterceptor, multi: true },
    /**
     * v1.6.1687 — permission 403 from any staff route (Asana 1216892546346406).
     *
     * Registered AFTER BillingInterceptor deliberately. Both inspect a 403 and
     * both re-throw, so order does not change behaviour — but the billing one
     * reading first keeps the "is this a billing block?" decision in one place,
     * and PermissionInterceptor's own guard excludes anything carrying
     * `data.reason` so the two can never both claim the same response.
     */
    { provide: HTTP_INTERCEPTORS, useClass: PermissionInterceptor, multi: true },
    // v1.6.253: Global handler that detects stale-deploy chunk-load failures
    // and auto-reloads so operators don't see a broken Analytics/etc. page after
    // we deploy while their tab is open.
    { provide: ErrorHandler, useClass: ChunkErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: NoAutofillService) => () => svc.init(),
      deps: [NoAutofillService],
      multi: true,
    },
  ]
};
